<template>
  <div :class="$style.ksFormGiftBox" :style="{ backgroundImage: `url(${backgrounImgUrl}/bg21.jpg)` }">
    <!-- 礼包选择列表 -->
    <div :class="$style.giftContent">
      <!-- 单个礼包列 -->
      <div :class="$style.giftList">
        <div
          v-for="(item, index) in giftList"
          :key="index"
          :class="$style.giftItem"
          :style="{ backgroundImage: `url(${item.bg})` }"
        >
        <!-- width="375"
            height="110" -->
          <!-- <van-image
            fit="cover"
            :src="item.bg"
          /> -->
          <div :class="$style.giftPrice">
            <Checkbox class="ksformGiftcheckbox" shape="square" v-model="item.priceChecked" @change="val => checkBoxChange(val, index)"></Checkbox>
            <div :class="$style.price">{{ item.curPrice }}元</div>
            <div :class="$style.originPrice">{{ item.oriPrice }}</div>
          </div>
        </div>


        <!-- 下边手机号码区域 -->
        <!-- 如果是换了个游戏呢，这里手机号还能重新输入吗 -->
        <div :class="$style.telphonenum" :style="{ height: `${historyMobile ? '120px' : '170px'}` }">
          <!-- 输入手机号 -->
          <div v-if="!historyMobile" :class="$style.phone">
            <div :class="$style.content">
              <van-image
                width="20"
                height="20"
                fit="cover"
                :src="`${backgrounImgUrl}/phone1.png`"
              />
              <Field
                v-model.trim="mobile"
                placeholder="请输入手机号"
                :class="$style.field"
                clearable
              ></Field>
            </div>
            <van-image
              width="280"
              height="10"
              fit="cover"
              :src="`${backgrounImgUrl}/line1.png`"
            />
          </div>
          <!-- 验证码 -->
          <div v-if="!historyMobile" :class="$style.phone">
            <div :class="$style.content">
              <van-image
                width="20"
                height="20"
                fit="cover"
                :src="`${backgrounImgUrl}/yanzhengma1.png`"
              />
              <Field
                :class="$style.field"
                v-model.trim="inputValidNum"
                placeholder="请输入验证码"
                clearable
              >
                <template v-slot:right-icon>
                  <div v-if="!count" :class="$style.verifyCode" @click="getCode" :style="{ backgroundImage: `url(${backgrounImgUrl}/btnbg1.png)` }">
                    获取
                  </div>
                  <div v-else :class="$style.verifyCode" :style="{ backgroundImage: `url(${backgrounImgUrl}/btnbg1.png)` }">
                    已发送{{count}}s
                  </div>
                </template>
              </Field>
            </div>
            <van-image
              width="280"
              height="10"
              fit="cover"
              :src="`${backgrounImgUrl}/line1.png`"
            />
          </div>

          <div v-if="historyMobile" :class="$style.historyPhone">
            <div :class="$style.content">{{ `${historyMobile.slice(0, 3)}****${historyMobile.slice(-4)}` }}</div>
            <van-image
              width="270"
              height="10"
              fit="cover"
              :src="`${backgrounImgUrl}/line1.png`"
            />
          </div>

          <!-- 立即领取 -->
          <div :class="$style.getreward" @click="getPayReward" >
            <van-image
              width="120"
              height="30"
              fit="cover"
              mode="aspectFil"
              :src="`${backgrounImgUrl}/reward1.png`"
            />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Image as VanImage, Checkbox, Field, Toast } from 'vant';
import CountDown from "@/mixins/countDown";
import { getPhoneCode, getKsFormGoodsList, preCreateKsFormOrder, createKsFormOrder, checkOrderPayResult, getUserRewardInfo, getKsFormGoodsListV2 } from '@/apis/ksForm';
import { backgrounImgUrl } from './config'
import { CDN_URL_1 } from "@/config";

export default {
  name: 'ksActivity-gift',
  components: {
    VanImage,
    Checkbox,
    Field
  },
  mixins: [CountDown],
  data () {
    return {
      backgrounImgUrl,
      giftList: [
        { bg: `${CDN_URL_1}/ksForm/gift11.png`, curPrice: 0.99, oriPrice: 100, priceChecked: false },
        { bg: `${CDN_URL_1}/ksForm/gift21.png`, curPrice: 0.5, oriPrice: 50, priceChecked: false },
        { bg: `${CDN_URL_1}/ksForm/gift31.png`, curPrice: 0.1, oriPrice: 10, priceChecked: false },
      ],

      mobile: '', // 手机号
      inputValidNum: '', // 验证码
      count: 0,
      historyMobile: '',
      // 广告过来的额外的信息参数，plan_id  appkey等
      extraParams: {},
      payTarget: {}, // 支付的奖励信息
      orderInfo: {}, // 订单信息
      pollTimer: null,
      isCheck: undefined,
      isRepetGetReward: false, // 重复领取的标记
      rewardTimer: null
    }
  },
  computed: {
    // 选择支付的商品信息
    selectTarget () {
      return this.giftList.find(it => it.priceChecked)
    }
  },
  created () {
    localStorage.removeItem('ksFormActivityCheck')
    this.extraParams = JSON.parse(localStorage.getItem('ksActivityQuery')) || {}
    this.getGiftList()
  },
  mounted () {
    this.historyMobile = localStorage.getItem("ksFormMobile") || '';
    this.isCheck = localStorage.getItem('ksFormActivityCheck')
    this.startRewardPollingCheck()
    setTimeout(() => {
      clearInterval(this.rewardTimer)
      this.rewardTimer = null
    }, 5000)
  },
  methods: {
    // 检查领取状态
    startRewardPollingCheck () {
      this.rewardTimer = setInterval(this.onCheckRewardRecord, 1000)
    },
    // 检查是否有过领取记录
    onCheckRewardRecord () {
      const checkReward = this.historyMobile && this.extraParams.appkey
      if (checkReward && !this.isCheck) {
        getUserRewardInfo({
          mobile: this.historyMobile,
          gameId: this.extraParams.appkey
        }).then(res => {
          if (res.data) {
            clearInterval(this.rewardTimer)
            this.rewardTimer = null
            // 有领过礼包码的时候，直接回到礼包码页面
            this.$router.push({
              path: '/ksForm/ksActivityGiftCode',
              query: {
                cdk: res.data.cdk
              }
            })
          }
        }).catch(() => {})
      }
    },
    isAndroid() {
      let u = navigator.userAgent;
      return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    },

    // 获取商品列表
    getGiftList () {
      getKsFormGoodsListV2({
        gameId: this.extraParams.appkey
      }).then(res => {
        const gift = {
          0: '奖励壹',
          1: '奖励贰',
          2: '奖励叁'
        }
        this.giftList = this.giftList.map((it, idx) => {
          const target = res.data.find(item => item.goodsName === gift[idx])
          if (target) {
            it.curPrice = +target.curPrice;
            it.oriPrice = +target.oriPrice;
            it.goodsId = target.goodsId;
            it.goodsName = target.goodsName;
          }
          return it
        })
      }).catch(() => {})
    },

    // 获取验证码
    getCode () {
      if (!this.mobile) {
        Toast('手机号不能为空')
        return;
      }
      getPhoneCode({
        mobile: this.mobile,
        gameId: this.extraParams.appkey
      }).then(res => {
        this.setTimer();
      }).catch((error) => {})
    },

    checkBoxChange (val, index) {
      if (val) {
        this.giftList.forEach((it, idx) => {
          index !== idx && (it.priceChecked = false);
        })
      }
    },

    getPayReward () {
      // if (this.pollTimer) {
      //   Toast('当前有未支付的订单，请支付后领取')
      //   return
      // }
      if (!this.mobile && !this.historyMobile) {
        Toast('手机号不能为空')
        return;
      }
      if (!this.giftList.some(it => it.priceChecked)) {
        Toast('请至少选择一个奖励礼包')
        return;
      }
      const params = {
        os: this.isAndroid() ? 'android' : 'ios',
        type: 4,
        userId: this.mobile || this.historyMobile,
        channelType: 4,
        money: this.selectTarget.curPrice,
        goodsId: this.selectTarget.goodsId, // 商品ID
        goodsName: this.selectTarget.goodsName, // 商品名
        num: 1,
        operateType: this.historyMobile ? 1 : 0, //  若没有记录过手机号 传0, 该手机号验证过验证码 传1
        exchangeRate: 1, // 汇率
        mobileCode: this.inputValidNum, // operateType = 0 时必传, operateType = 1时不传
        gameId: this.extraParams.appkey || '',
        days: 1 // 天数，因为这后端复用的云挂机的相关逻辑，这里固定传个1，要不然接口报错
      }
      // 1秒内不能重复领取
      if (this.isRepetGetReward) return;
      preCreateKsFormOrder(params).then(res => {
        // 预创建订单成功之后再存一下用户输入过的手机号
        // 因为有这个缓存的时候，下次进来不用再输验证码了，
        // 后端校验验证码也是在预创建订单这个接口校验的，这个接口成功了说明上一次的验证码是正确的
        localStorage.setItem("ksFormMobile", this.mobile || this.historyMobile)
        this.orderInfo = res.data
        this.cratePayOrderFn()
      }).catch((error) => {
        this.isRepetGetReward = false
        // 5016错误码是手机号未验证过，需要重新验证
        if (error.code === 5016) {
          localStorage.removeItem("ksFormMobile")
          this.historyMobile = ''
        }
        // 历史已经领取过的话，带着cdk到礼包码页面
        if (error.code === 5014) {
          localStorage.setItem("ksFormMobile", this.mobile || this.historyMobile)
          this.historyMobile = this.mobile || this.historyMobile
          this.onCheckRewardRecord()
        }
      })
    },

    // 创建支付订单
    cratePayOrderFn () {
      const { preOrderSn, callbackUrl, payAppId } = this.orderInfo
      const notifyUrl = `${window.location.origin}/ksForm/ksActivityPayResult`
      const params = {
        userId: this.mobile || this.historyMobile,
        outOrderSn: preOrderSn,
        goodsId: this.selectTarget.goodsId,
        payType: 26, // 支付类型 微信-26 支付部-57
        payAppId,
        callbackUrl,
        gameId: this.extraParams.appkey || '',
        downloadUrl: this.extraParams.download_url || '', // 计划链接
        planId: this.extraParams.plan_id || '',
        callback: this.extraParams.callback || '',
        syncNotifyUrl: `http://static.hzwxbz3.cn/Lianyun/font_end/wxhd/ksForm/middleJumpPage.html?ksFormUrl=${encodeURIComponent(notifyUrl)}`
      }

      createKsFormOrder(params).then(res => {
        const { payUrl } = res.data
        window.open(payUrl, '_blank')
        this.startPollingCheck()
      }).catch(() => {
        this.isRepetGetReward = false
      })
    },

    // 检查订单的支付状态
    onCheckOrderStatus () {
      const { preOrderSn } = this.orderInfo
      checkOrderPayResult({ outOrderSn: preOrderSn }).then(res => {
        if (res.data.paySuccess) {
          clearInterval(this.pollTimer)
          this.pollTimer = null
          this.$router.push({
            path: '/ksForm/ksActivityGiftCode'
          })
        }
      }).catch(() => {})
    },

    startPollingCheck () {
      this.pollTimer = setInterval(this.onCheckOrderStatus, 1000)
    },

    // 判断重复领取的逻辑
    // 2秒内不重复领取，如果预创建订单或者创建订单接口报错，可再次领取
    isRepetGetRewardTimer () {
      this.isRepetGetReward = true
      setTimeout(() => {
        this.isRepetGetReward = false
      }, 2000)
    }

  }
}
</script>

<style lang="scss">
.ksformGiftcheckbox {
  .van-checkbox__icon--checked .van-icon {
    background-color: #1c1a1a;
    border-color: #1c1a1a;
  }
  .van-checkbox__icon {
    background-color: #1c1a1a;
  }
  .van-checkbox__icon--checked .van-icon {
    color: #61ff4a;
  }
}
</style>
<style lang="scss" module>
.ksFormGiftBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  // background-image: url('./qietu/bg2.jpg');
  background-size: 100% 100%;
  background-position: center; /* 让图片居中显示 */  
  background-repeat: no-repeat;
  position: relative;
  background-attachment: local; /* 背景随盒子滚动 */

  .giftContent {
    width: 100%;
    height: calc(100vh - 270px);
    // height: 100%;
    position: absolute;
    bottom: 0;
    // display: flex;
    // justify-content: center;  
    // align-items: center;  
    .giftList {
      width: 100%;
      height: 100%;
      text-align: center;
      .giftItem {
        max-width: 375px;
        // width: 100%;
        height: 100px;
        margin:auto;
        position: relative;

        background-size: 100%;
        background-position: center; /* 让图片居中显示 */  
        background-repeat: no-repeat;

        .giftPrice {
          display: flex;
          align-items: center;
          position: absolute;
          right: 35px;
          bottom: 40px;
          width: 100px;
          text-align: left;
          .price {
            // width: 28px;
            // height: 12px;
            margin: 0 5px;
            border: 1px solid #240d0d;
            font-size: 14px;
            font-family: FZCuSong-B09S, FZCuSong-B09S-Regular;
            font-weight: 400;
            text-align: left;
            color: #ffff58;
            line-height: 3.33px;
            // letter-spacing: 0.37px;
          }
          .originPrice {
            // width: 20px;
            // height: 9.33px;
            font-size: 12px;
            font-family: FZCuSong-B09S, FZCuSong-B09S-Regular;
            font-weight: 400;
            text-align: left;
            color: #f0e5c6;
            line-height: 2.67px;
            // letter-spacing: 0.29px;
            text-decoration: line-through;  
            text-shadow: -0.67px 0px 0.49px 0.17px rgba(40,40,40,0.75); 
          }
        }
      }
    }

    .telphonenum {
      // margin-top: 20px;
      // width: 100%;
      max-width: 375px;
      height: 170px;
      // padding: 0 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding-top: 10px;
      margin: 0 auto;
      .phone {
        max-width: 375px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;

        .content {
          display: flex;
          align-items: center;
          .verifyCode {
            width: 80px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-size: 10px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            color: #413129;
            // background-image: url('./qietu/btnbg.png');
            background-size: 100% 100%;
            background-position: center; /* 让图片居中显示 */  
            background-repeat: no-repeat;
            font-size: 14px;
          }
        }
      }
      .historyPhone {
        // padding: 15px 0;
        opacity: 0.5;
        font-size: 13px;
        font-family: Dream Han Sans SC, Dream Han Sans SC-W11;
        font-weight: normal;
        text-align: center;
        color: #ffffff;
        // letter-spacing: 0.53px;
      }
      .field {
        border: none;
        padding: 0px 18px;
        background: transparent;
        width: 250px;
        height: 26px;
        :global {
          input {
            color: #7c7c7c;
          }
        }
      }
    }

    .getreward {
      width: 300px;
      // height: 100px;
      text-align: center;
      margin: 15px auto 0;
    }
  }
}
</style>